export default __webpack_public_path__ + "static/media/11.c8313fb6.pdf";